// TODO: remove in favor of paymentMethods
export const PAYMENT_METHOD_CARD = 'stripe'
export const PAYMENT_METHOD_IDEAL = 'ideal'
export const PAYMENT_METHOD_BANK_TRANSFER = 'bank-transfer'
export const PAYMENT_METHOD_MERCADO_PAGO = 'mercado-pago'
export const PAYMENT_METHOD_P24 = 'p24'

export const PAYMENT_SUCCESS = 'success'
export const PAYMENT_FAILURE = 'failure'
export const PAYMENT_PENDING = 'pending'
export const PAYMENT_STATUS = [PAYMENT_SUCCESS, PAYMENT_FAILURE, PAYMENT_PENDING]


export const userCTA = {
    NONE: 'none',
    SUPPORT: 'support',
    FACE_CHECKIN: 'face-checkin'
}

export const paymentMethods = {
    CARD: 'stripe',
    IDEAL: 'ideal',
    BANK_TRANSFER: 'bank-transfer',
    MERCADO_PAGO: 'mercado-pago',
    P24: 'p24'
}

export const experienceTypes = {
    PICA_STANDARD: 'p', // eg: list of photos in preview
    MINIMAL: 'm', // none
}

export const checkinErrors = {
  CAMERA_PERMISSION_DENIED: 'camera_permission_denied',
  SERVER_ERROR: 'server_error',
}
// Domains showing the "Powered by" under the login/signup forms instead of on top, with optional link
export const bottomPoweredByUrls = {
    hublot: 'https://business.getpica.com/?utm_source=hublot.getpica.com&utm_medium=website&utm_campaign=hublot',
    rolex: null,
}
